import { getLink } from "../../documents/components/DocumentLinkProvider";
import { MyTask } from "../myTasksSlice";


type RawTask = MyTask & {
    Link?: string,
};

const entityTypeToLink = (entityType: string, entityId: string): string | null => {
    const normalized = entityType.toUpperCase();

    switch (normalized) {
        case "URS":
            return `/urs/edit/${entityId}`;
        case "SUPPLIER_IMPORTED_URS":
            return `/supplier-imported-urs/edit/${entityId}`;
        case "IMPORTED_DOCUMENT":
            return `/imported-documents/edit/${entityId}`;
        case "DOCUMENT":
            return `/document/edit/${entityId}`;
        default:
            return null;
    }
};

export const taskTargetLink = (task: MyTask): string => {

    const rawTask = task as RawTask;
    return task.link ?? rawTask.Link ?? "";
};

export const taskPrimaryText = (task: MyTask): string => {
    const title = task.documentInfo?.title ?? "";
    const number = task.documentInfo?.number ?? "";

    if (number && title) {
        return `${number} - ${title}`;
    }

    if (title || number) {
        return title || number;
    }

    if (task.taskDescription && task.taskDescription.trim().length > 0) {
        return task.taskDescription;
    }

    return "Task";
};
